// 权限：【项目主管 project_supervisor，中心主任 center_supervisor，超管super_supervisor】
export const role = [
  'project_supervisor',
  'center_supervisor',
  'super_supervisor'
]

// 酒店类型
export const hotel = {
  breakfasts: {
    breakfastdouble: '含双早',
    nobreakfast: '不含早餐'
  },
  hotel_types: {
    inter_three_star: '校内三星',
    inter_two_star: '校内二星',
    outer_four_star: '校外四星',
    outer_three_star: '校外三星',
    three_campus: '武大三环校区',
    // 追加
    three_down_star: '三星及以下',
    three_star: '三星级',
    comfortable_three_star: '舒适型（三星）',
    four_star: '四星级',
    comfortable_four_star: '舒适型（四星）',
    high_end: '高端酒店',
    five_star: '准五星级'
  }
}

// 课程类型
export const courseType = [{
  value: 'boutique',
  label: '品牌课程'
}, {
  value: 'professional',
  label: '专业课程'
}, {
  value: 'public',
  label: '公共课程'
}, {
  value: 'onsite',
  label: '现场教学'
}]



// WEBPACK FOOTER //
// ./src/utils/cadre.config.js